(() => {
  if (window.honjienDeliveryEstimateLoaded) return;
  window.honjienDeliveryEstimateLoaded = true;

  const boxSelector = '.honjien-delivery-estimate';
  const states = new WeakMap();
  let scheduled = false;

  function getScope(box) {
    return (
      box.closest('product-info') ||
      box.closest('.shopify-section')
    );
  }

  function getVariantId(scope) {
    const input = scope.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );
    return input ? input.value : '';
  }

  function getQuantity(scope) {
    const input = scope.querySelector('input[name="quantity"]');
    const value = input ? Number.parseInt(input.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function updateText(box, scope) {
    const target = box.querySelector('[data-delivery-text]');
    if (!target) return;

    const quantity = getQuantity(scope);
    const inventory = Number(box.dataset.inventory) || 0;
    const managed = Boolean(box.dataset.inventoryManagement);
    const available = box.dataset.available === 'true';
    const continueSelling = box.dataset.inventoryPolicy === 'continue';

    // 購入可能かと、在庫で数量をまかなえるかは別に判定します。
    const enoughStock = !managed || quantity <= inventory;
    const canPurchase =
      available && (!managed || enoughStock || continueSelling);

    const text =
      canPurchase && enoughStock
        ? box.dataset.instock
        : box.dataset.outofstock;

    if (target.textContent.trim() !== text) {
      target.textContent = text || '在庫切れ（納期未定）';
    }
  }

  async function refreshBox(box) {
    const scope = getScope(box);
    if (!scope) return;

    const variantId = getVariantId(scope);
    if (!variantId) return;

    let state = states.get(box);
    if (!state) {
      state = { pendingId: '', controller: null };
      states.set(box, state);
    }

    // 読み込み中に別の種類へ戻した場合も、古い取得を中止します。
    if (state.pendingId && state.pendingId !== variantId) {
      state.controller.abort();
      state.pendingId = '';
    }

    if (box.dataset.variantId === variantId) {
      updateText(box, scope);
      return;
    }

    if (state.pendingId === variantId) return;

    const sectionId = box.dataset.sectionId;
    if (!sectionId) return;

    const controller = new AbortController();
    state.controller = controller;
    state.pendingId = variantId;

    const target = box.querySelector('[data-delivery-text]');
    if (target) target.textContent = '配送予定を確認中…';

    try {
      const productUrl = scope.dataset.url || window.location.pathname;
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url, {
        signal: controller.signal,
      });

      if (!response.ok) throw new Error('Delivery information unavailable');

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const freshBox = documentFragment.getElementById(box.id);
      if (!freshBox || freshBox.dataset.variantId !== variantId) {
        throw new Error('Delivery information not found');
      }

      if (!box.isConnected || getVariantId(scope) !== variantId) return;

      [
        'variantId',
        'inventory',
        'inventoryManagement',
        'inventoryPolicy',
        'available',
        'instock',
        'outofstock',
      ].forEach((key) => {
        box.dataset[key] = freshBox.dataset[key] || '';
      });

      updateText(box, scope);
    } catch (error) {
      if (error.name !== 'AbortError' && box.isConnected) {
        if (getVariantId(scope) === variantId && target) {
          target.textContent =
            '配送予定を取得できませんでした。再読み込みしてください。';
        }
        console.warn('Honjien delivery estimate:', error);
      }
    } finally {
      if (state.controller === controller) {
        state.pendingId = '';
        state.controller = null;
      }
    }
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll(boxSelector).forEach(refreshBox);
    });
  }

  function start() {
    scheduleRefresh();

    document.addEventListener('input', scheduleRefresh);
    document.addEventListener('change', scheduleRefresh);

    document.addEventListener('click', (event) => {
      if (event.target.closest('.quantity__button')) {
        scheduleRefresh();
      }
    });

    // Dawnが種類変更後に商品情報を更新した場合も再確認します。
    const observer = new MutationObserver((mutations) => {
      const hasProductUpdate = mutations.some((mutation) => {
        const element =
          mutation.target.nodeType === Node.ELEMENT_NODE
            ? mutation.target
            : mutation.target.parentElement;

        if (!element || element.closest(boxSelector)) return false;

        return (
          element.closest('product-info') ||
          Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node.matches(boxSelector) ||
                node.querySelector(boxSelector))
          )
        );
      });

      if (hasProductUpdate) scheduleRefresh();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
